import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import * as API from '../../Endpoints/Endpoints'; // Adjust the path based on your project structure

const UpdateGameMaster = () => {
  const [gameMasterData, setGameMasterData] = useState({
    gamecategory: '',
    gamename: '',
    gamecode: '',
    gamesymbol: '',
    gameboardtype: '',
    complexity: '',
  });

  const navigate = useNavigate();
  const { gamemasterid } = useParams(); // Ensure this is correct and available in the URL

  useEffect(() => {
    fetchGameMasterData();
  }, [gamemasterid]); // Add gamemasterid as a dependency to re-fetch when it changes
  
  const fetchGameMasterData = () => {
    axios({
      url: API.GET_MASTER_BYID(gamemasterid),
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((res) => {
        setGameMasterData(res.data);  // Assuming the data is the full game master object
      })
      .catch((err) => {
        alert('Error fetching game master data: ' + err);
      });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setGameMasterData({ ...gameMasterData, [name]: value });
  };

  const updateGameMaster = (e) => {
    e.preventDefault();
    axios.put(API.PUT_MASTER_API(gamemasterid), gameMasterData, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((res) => {
        alert('Game master updated successfully');
        navigate('/gamemastertable'); // Navigate back to game master table after successful update
      })
      .catch((err) => {
        console.error('Error updating game master:', err);
        alert('Error updating game master: ' + err.message);
      });
  };

  const goBack = () => {
    navigate('/gamemastertable'); // Go back to the game master table
  };

  return (
    <div className="bg-[#B5B5B5] h-auto pb-20 pt-10">
      <div className="max-w-4xl mx-auto pt-10">
        <form onSubmit={updateGameMaster} className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">Game Category</label>
            <input
              type="text"
              name="gamecategory"
              value={gameMasterData.gamecategory}
              onChange={handleInputChange}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">Game Name</label>
            <input
              type="text"
              name="gamename"
              value={gameMasterData.gamename}
              onChange={handleInputChange}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">Game Code</label>
            <input
              type="text"
              name="gamecode"
              value={gameMasterData.gamecode}
              onChange={handleInputChange}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">Game Symbol</label>
            <input
              type="text"
              name="gamesymbol"
              value={gameMasterData.gamesymbol}
              onChange={handleInputChange}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">Game Board Type</label>
            <input
              type="text"
              name="gameboardtype"
              value={gameMasterData.gameboardtype}
              onChange={handleInputChange}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">Complexity</label>
            <input
              type="text"
              name="complexity"
              value={gameMasterData.complexity}
              onChange={handleInputChange}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            />
          </div>

          <div className="flex items-center justify-between">
            <button
              type="submit"
              className="bg-[#e64a32] hover:bg-[#e64a32] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            >
              Update
            </button>
            <button
              type="button"
              onClick={goBack}
              className="bg-[#e64a32] hover:bg-[#e64a32] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            >
              Go Back
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdateGameMaster;
